<template>
    <div>
        <section id="banner" class="bg-secondary">
            <div class="page-banner-pa py-4"> <!-- mobile -->
                <div class="container page-banner-inner-text py-4">
                    <div class="row">
                        <div class="col-12 text-center">
                            <h1 class="fs-3 text-white bold">CLASSE {{classClass + '' + classSection}}</h1>
                            <p class="fs-1-3 semibold text-white mb-1">INVIA QUI LE FOTO PER PARTECIPARE</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="container pt-5"> <!-- first form (primary) -->
            <div class="row justify-content-center">
                <div class="col-12 col-xl-9 col-xxl-7 text-center pt-5 mt-4">
                    <h2 class="fs-2-7 mb-4">Condividi il vostro “Manifesto <i>Stammi Bene!</i>”</h2>
                </div>

                <div class="col-xl-9 col-xxl-7 text-center">
                    <p>
                        Coinvolgi la classe nell’elaborazione di <strong>3 idee per un benessere “Buono, Sano e Giusto”</strong> per creare il vostro <strong>“Manifesto <i>Stammi Bene!</i>”</strong>:
                        potete realizzarlo <strong>in forma grafica e/o testuale</strong> (es. disegno, poster, testo scritto, mappa concettuale).
                        Poi <strong>fotografa l’elaborato e caricalo qui</strong>: per ogni classe puoi inviare <strong>fino a 5 foto di Manifesti</strong>, diversi tra loro!
                    </p>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 py-4">
                    <form @submit.prevent="submitMedia('primary')" ref="outdoorForm">
                        <div class="row justify-content-center">
                            <div class="col-8 col-xl-9 col-xxl-8">
                                <div class="row justify-content-center">
                                    <div class="col-12 form-group mb-0 mt-1 text-center">
                                        <div>
                                            <label for="file-upload" class="custom-file-upload p-0 border-0 mt-1" role="button" :disabled="isBtnMediaDisabled" style="z-index:3;">
                                                <a type="button" class="btn btn-green btn-lg rounded-pill mx-4">SCEGLI FOTO</a>
                                            </label>
                                        </div>
                                        <small class="fs-0-7">Puoi inviare foto di massimo 10 MB e in formato .jpg .jpeg o .png. Contributi doppi o duplicati verranno eliminati in fase di moderazione.</small><br>
                                        <input id="file-upload" type="file" ref="file1" @change="processFile($event)" accept="image/png, image/jpeg" :disabled="isBtnMediaDisabled || spinners.isMediaSubmitting">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-center" v-if="urlPreview">
                                <p v-html="msgSelectedFile" class="mt-4"></p>
                                <img :src="urlPreview" alt="Preview" style="max-width:180px;height:auto;">
                            </div>

                            <div class="col-12 form-group text-center mt-3 mb-2">
                                <button type="submit" class="btn btn-secondary rounded-pill px-4 mt-2" :disabled="isBtnMediaDisabled || spinners.isMediaSubmitting">Invia <i class="fas fa-circle-notch fa-spin va-sub ml-2" :class="[spinners.isMediaSubmitting2 ? 'd-inline-block' : 'd-none']"></i></button>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center" style="min-height: 24px;">
                                    <div v-html="msgMedia"></div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div id="works-list" class="py-4">
            <items-contents-list
                items-type="primary"
                component-title="RIEPILOGO FOTO MANIFESTI INVIATE"
                component-paragraph='Puoi sostituire solo le foto “in approvazione”. Per farlo, clicca sull’icona “cestino” e poi torna al pulsante “Scegli foto” per inviare una nuova foto. Non puoi eliminare una foto approvata.'
                :works-list-data="worksListData"
                :thema-url="themaUrl"
                @refreshList="refreshList"
            ></items-contents-list>
        </div>

        <div class="container pt-5"> <!-- second form (secondary) -->
            <div class="row justify-content-center">
                <div class="col-12 col-xl-9 col-xxl-7 text-center pt-5 mt-4">
                    <h2 class="fs-2-7 mb-4">Le foto testimonianze: siate esempio di benessere!</h2>
                </div>

                <div class="col-xl-9 col-xxl-7 text-center">
                    <p>
                        <strong>Fotografa la classe durante la visione dei video o l’esecuzione di un’attività tra quelle proposte</strong>.
                        Scegli le inquadrature che secondo te meglio descrivono il vostro percorso, poi invia <strong>ﬁno a 5 foto</strong> che raccontano l’esperienza di questa classe.
                        <strong>Ricorda: fotografa gli studenti di spalle oppure oscura i loro volti prima di inviare le foto</strong>.
                    </p>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 py-4">
                    <form @submit.prevent="submitMedia('secondary')" ref="outdoorForm2">
                        <div class="row justify-content-center">
                            <div class="col-8 col-xl-9 col-xxl-8">
                                <div class="row justify-content-center">
                                    <div class="col-12 form-group mb-0 mt-1 text-center">
                                        <div>
                                            <label for="file-upload2" class="custom-file-upload p-0 border-0 mt-1" role="button" :disabled="isBtnMediaDisabled2" style="z-index:3;">
                                                <a type="button" class="btn btn-green btn-lg rounded-pill mx-4">SCEGLI FOTO</a>
                                            </label>
                                        </div>
                                        <small class="fs-0-7">Puoi inviare foto di massimo 10 MB e in formato .jpg .jpeg o .png. Contributi doppi o duplicati verranno eliminati in fase di moderazione.</small><br>
                                        <input id="file-upload2" type="file" ref="file2" @change="processFile2($event)" accept="image/png, image/jpeg" :disabled="isBtnMediaDisabled2 || spinners.isMediaSubmitting2">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-center" v-if="urlPreview2">
                                <p v-html="msgSelectedFile2" class="mt-4"></p>
                                <img :src="urlPreview2" alt="Preview" style="max-width:180px;height:auto;">
                            </div>

                            <div class="col-12 form-group text-center mt-3 mb-2">
                                <button type="submit" class="btn btn-secondary rounded-pill px-4 mt-2" :disabled="isBtnMediaDisabled2 || spinners.isMediaSubmitting2">Invia <i class="fas fa-circle-notch fa-spin va-sub ml-2" :class="[spinners.isMediaSubmitting2 ? 'd-inline-block' : 'd-none']"></i></button>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center" style="min-height: 24px;">
                                    <div v-html="msgMedia2"></div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div id="works-list" class="py-4">
            <items-contents-list
                items-type="secondary"
                component-title="RIEPILOGO FOTO TESTIMONIANZE INVIATE"
                component-paragraph='Puoi sostituire solo le foto “in approvazione”. Per farlo, clicca sull’icona “cestino” e poi torna al pulsante “Scegli foto” per inviare una nuova foto. Non puoi eliminare una foto approvata.'
                :works-list-data="worksListData2"
                :thema-url="themaUrl"
                @refreshList="refreshList"
            ></items-contents-list>
        </div>

        <div id="go-back" class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-green btn-lg rounded-pill px-4" @click.prevent="$emit('goBack')"><span class="va-m">TORNA ALL’AREA DOCENTE</span> <i class="fas fa-circle-notch fa-spin va-sub ml-2 d-none"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import ItemsContentsList from './ItemsContentsList.vue'
import { setTimeout } from 'core-js';

export default {
    props: ['idClass', 'classSection', 'classClass', 'themaUrl', 'pdfPrivacy', 'docLiberatoria', 'bannerImg', 'bannerImgXl', 'bannerImgMobile'],
    components: {ItemsContentsList},

    data() {
        return {
            ajaxObj: window.ajax_object,

            isBtnFormDisabled: true,
            isBtnMediaDisabled: false,
            isBtnMediaDisabled2: false,

			spinners: {
                isMediaSubmitting2: false,
                isMediaSubmitting: false
			},

            form: {
                announcement: '',
                mediaFileSelected: '',
                idWork: 0,
                prevMediaId: 0,
                privacy: 0
            },
            form2: {
                announcement: '',
                mediaFileSelected: '',
                idWork: 0,
                prevMediaId: 0,
                privacy: 0
            },

            urlPreview2: '',
            urlPreview: '',
			msgSelectedFile: '',
            msgSelectedFile2: '',
            msgMedia: '',
            msgMedia2: '',

            worksListData2: {},
            worksListData: {},

            primaryWorksCount: 0,
            secondaryWorksCount: 0
        }
    },

    methods: {
		submitMedia(type) {
			if(((this.form2.mediaFileSelected == null || this.form2.mediaFileSelected == '' || this.form2.mediaFileSelected == undefined) && this.form2.prevMediaId == 0) && type == 'secondary') {
                this.msgMedia2 = 'Attenzione: selezionare un immagine da inviare!'
            } else if(((this.form.mediaFileSelected == null || this.form.mediaFileSelected == '' || this.form.mediaFileSelected == undefined) && this.form.prevMediaId == 0) && type == 'primary') {
                this.msgMedia = 'Attenzione: selezionare un immagine da inviare!'
			} else {
                let action = ''
                if(type == 'secondary') {
                    this.spinners.isMediaSubmitting2 = true
                    this.msgMedia2 = ''
                    action = 'nl_submit_media'
                } else if(type == 'primary') {
                    this.spinners.isMediaSubmitting = true
                    this.msgMedia = ''
                    action = 'nl_submit_media'
                }

				let url = this.ajaxObj.ajax_url
                let contentType = 'application/json';

				let formData = new FormData();
				formData.append('action', action)
				formData.append('_nounce_value', this.ajaxObj._nounce_value)
                formData.append('class_id', this.idClass)
                formData.append('work_type', type)

                if(type == 'primary') {
                    contentType = 'multipart/form-data'
                    formData.append('media', this.form.mediaFileSelected)
                    formData.append('prev_media_id', this.form.prevMediaId)
                    formData.append('id_work', this.form.idWork)
                    formData.append('announcement', this.form.announcement)
                    formData.append('privacy', this.form.privacy)
                } else if(type == 'secondary') {
                    contentType = 'multipart/form-data'
                    formData.append('media', this.form2.mediaFileSelected)
                    formData.append('prev_media_id', this.form2.prevMediaId)
                    formData.append('id_work', this.form2.idWork)
                    formData.append('announcement', this.form2.announcement)
                    formData.append('privacy', this.form2.privacy)
                }

				axios.post(url, formData, {
						headers:{
							'Content-Type' : contentType
						}
					})
					.then((response) => {
						// console.log(response.data)
						if(response.data.error == '') {
                            if(type == 'primary') {
                                this.msgMedia = response.data.msg
                                this.resetForm()
                            } else if(type == 'secondary') {
                                this.msgMedia2 = response.data.msg
                                this.resetForm2()
                            }
                            this.getWorksData(type)
						} else {
                            if(type == 'primary') {
                                this.msgMedia = response.data.error
                            } else if(type == 'secondary') {
                                this.msgMedia2 = response.data.error
                            }

						}
                        this.getWorksCount(type)
						// this.getClassWorksData()
                        if (type == 'secondary') {
                            this.spinners.isMediaSubmitting2=false
                        } else if(type == 'primary') {
                            this.spinners.isMediaSubmitting = false
                        }
					}, (error) => {
                        if (type == 'secondary') {
                            this.spinners.isMediaSubmitting2 = false
                        } else if(type == 'primary') {
                            this.spinners.isMediaSubmitting = false
                        }
						console.log(error);
					});
			}
		},

		processFile(event) {
			// console.log(event.target.files[0])
            this.msgMedia = ''
			this.urlPreview = ''
			this.urlPreview = window.URL.createObjectURL(event.target.files[0])
			this.form.mediaFileSelected = event.target.files[0]
			this.msgSelectedFile = 'File selezionato: <strong>' + this.form.mediaFileSelected.name + '</strong>'
		},

		processFile2(event) {
			// console.log(event.target.files[0])
            this.msgMedia2 = ''
			this.urlPreview2 = ''
			this.urlPreview2 = window.URL.createObjectURL(event.target.files[0])
			this.form2.mediaFileSelected = event.target.files[0]
			this.msgSelectedFile2 = 'File selezionato: <strong>' + this.form2.mediaFileSelected.name + '</strong>'
		},

        resetForm() {
            this.urlPreview = ''
            this.form.mediaFileSelected = ''
            this.form.announcement = ''
            this.$refs.outdoorForm.reset()
        },

        resetForm2() {
            this.urlPreview2 = ''
            this.form2.mediaFileSelected = ''
            this.form2.announcement = ''
            this.$refs.outdoorForm2.reset()
        },

        getWorksData(type) {
            let url = this.ajaxObj.ajax_url

            let formData = new FormData();
            formData.append('action', 'nl_get_works_list')
            formData.append('_nounce_value', this.ajaxObj._nounce_value)
            formData.append('class_id', this.idClass)
            formData.append('work_type', type)

			axios.post(url, formData)
				.then((response) => {
                    // console.log(response.data)
                    if(type == 'secondary') {
                        this.worksListData2 = response.data.worksData
                    } else if(type == 'primary') {
                        this.worksListData = response.data.worksData
                    }
				}, (error) => {
					console.log(error);
				});
        },

        checkSubmitIsDisabled() {
            this.isBtnFormDisabled = true
            Object.entries(this.form).forEach(([key, val]) => {
                if(key != 'idWork') {
                    if(val.status != 1 && this.isBtnFormDisabled === true) {
                        this.isBtnFormDisabled = false
                    }
                }
            });
        },

        refreshList(type) {
            this.getWorksData(type)
        },

        getWorksCount(type) {
            let url = this.ajaxObj.ajax_url

            let formData = new FormData();
            formData.append('action', 'nl_get_works_count')
            formData.append('_nounce_value', this.ajaxObj._nounce_value)
            formData.append('class_id', this.idClass)
            formData.append('work_type', type)

			axios.post(url, formData)
				.then((response) => {
                    // console.log(response.data)
                    if(type == 'secondary') {
                        this.secondaryWorksCount = response.data.count
                        if(this.secondaryWorksCount >= 5) {
                            this.isBtnMediaDisabled2 = true
                            this.msgMedia2 = 'Ottimo! Hai raggiunto il numero massimo di contributi';
                        } else {
                            this.isBtnMediaDisabled2 = false
                        }
                    } else if(type == 'primary') {
                        this.primaryWorksCount = response.data.count
                        if(this.primaryWorksCount >= 5) {
                            this.isBtnMediaDisabled = true
                            this.msgMedia = 'Ottimo! Hai raggiunto il numero massimo di contributi';
                        } else {
                            this.isBtnMediaDisabled = false
                        }
                    }
                }, (error) => {
					console.log(error);
				});
        }
    },

    mounted() {
        this.getWorksData('secondary')
        this.getWorksData('primary')
        setTimeout(() => {
            window.scrollTo(0,0);
        }, 350);

    }
}
</script>

<style scoped>
    .fa-trash-can {transition: all .3s ease-in-out;}
    .fa-trash-can:hover {
        opacity: 0.6;
    }
    .custom-file-upload:hover {
        opacity: .7;
        background-color: transparent !important;
    }
</style>